import type { CartCleanupService, PaymentConfig } from "../../types/payment";

/** сервис очистки корзины */
export function createCartCleanupService(config: PaymentConfig): CartCleanupService {
	return {
		cleanupAndNavigate(path: string | null, clearTokens: boolean, withSave: boolean = false): void {
			config.deleteCart(path, clearTokens, withSave);
		},

		cleanup(clearTokens: boolean): void {
			config.deleteCart(null, clearTokens);
		},

		clearTokens(): void {
			config.deleteCart(null, true);
		},

		resetStores(): void {
			config.resetStores();
		},
	};
}
